/**
 * GENERATED by `bun run scripts/sync-field-labels.ts`. Do not edit.
 *
 * @remarks
 * Labels for request field names and their selectable options, in de. Importing this module
 * registers them and re-renders every mounted form, exactly like the chrome catalogue beside it.
 * Regenerate with `bun run generate`; the source of truth is the API, not this file.
 */

import { registerFieldLabels } from '../../i18n/registry.js';

registerFieldLabels('de', {
	fields: {
		allowDuplicates: 'Doppelte Karten zulassen',
		allowReversals: 'Umgekehrte Karten zulassen',
		antardasha: 'Antardasha',
		approximateDate: 'Ungefähres Datum',
		arcana: 'Arkana',
		aspectTypes: 'Aspekttypen',
		avasthaInfo: 'Avastha-Details einschließen',
		ayanamsa: 'Ayanamsa',
		ayanamsaValue: 'Benutzerdefinierter Ayanamsa-Wert',
		biorhythm: 'Biorhythmus',
		birthData: 'Geburtsdaten',
		birthDate: 'Geburtsdatum',
		birthLatitude: 'Geburtsbreite',
		birthLongitude: 'Geburtslänge',
		birthTime: 'Geburtszeit',
		chakra: 'Chakra',
		color: 'Farbe',
		context: 'Wo du es gesehen hast',
		coordinateSystem: 'Koordinatensystem',
		count: 'Anzahl',
		currentYear: 'Jahr',
		date: 'Datum',
		datetime: 'Zeitpunkt',
		day: 'Tag',
		division: 'Varga',
		domainWeights: 'Gewichtung der Bereiche',
		domains: 'Bereiche',
		element: 'Element',
		endDate: 'Enddatum',
		endDatetime: 'Endzeitpunkt',
		expression: 'Ausdruckszahl',
		family: 'Yoga-Familie',
		focus: 'Fokus',
		fullName: 'Vollständiger Name',
		horaryNumber: 'Horary number',
		houseSystem: 'Häusersystem',
		id: 'ID',
		include: 'Zusätzliche Himmelskörper',
		interpretation: 'Positionsbedeutung',
		intervalMinutes: 'Intervall in Minuten',
		iso2: 'Ländercode',
		lang: 'Sprache',
		latitude: 'Breitengrad',
		letter: 'Anfangsbuchstabe',
		lifePath: 'Lebenszahl',
		limit: 'Ergebnisse pro Seite',
		lines: 'Linienmuster',
		longitude: 'Längengrad',
		mahadasha: 'Mahadasha',
		members: 'Gruppenmitglieder',
		minSignificance: 'Mindestsignifikanz',
		minStrength: 'Mindeststärke',
		modernPlanets: 'Moderne Planeten einschließen',
		month: 'Monat',
		name: 'Name',
		natalChart: 'Geburtshoroskop',
		nodeType: 'Mondknotentyp',
		number: 'Zahl',
		offset: 'Zu überspringende Ergebnisse',
		orb: 'Orbis',
		person1: 'Person 1',
		person2: 'Person 2',
		personA: 'Person A',
		personB: 'Person B',
		planet: 'Planet',
		planets: 'Planeten',
		positions: 'Kartenpositionen',
		pratyantardasha: 'Pratyantardasha',
		q: 'Suche',
		question: 'Deine Frage',
		relocationLatitude: 'Standortbreite',
		relocationLongitude: 'Standortlänge',
		returnDate: 'Rückkehrdatum',
		returnYear: 'Rückkehrjahr',
		scheme: 'Karaka-Schema',
		seed: 'Startwert',
		sign: 'Tierkreiszeichen',
		significators: 'KP-Signifikatoren einschließen',
		sookshma: 'Sookshma',
		soulUrge: 'Herzenswunschzahl',
		spreadName: 'Name des Legesystems',
		startDate: 'Startdatum',
		startDatetime: 'Startzeitpunkt',
		strictOrbs: 'Engere Orben verwenden',
		suit: 'Farbe',
		system: 'Avastha-System',
		targetDate: 'Zieldatum',
		targetMonth: 'Zielmonat',
		time: 'Zeit',
		timezone: 'Zeitzone',
		top: 'Top-Ereignisse pro Zeitfenster',
		transitDate: 'Transitdatum',
		transitTime: 'Transitzeit',
		type: 'Mustertyp',
		vedic: 'Vedisch',
		western: 'Westlich',
		year: 'Jahr',
		zodiac: 'Tierkreiszeichen',
	},
	enums: {
		'arcana.major': 'Große Arkana',
		'arcana.minor': 'Kleine Arkana',
		'ayanamsa.custom': 'Benutzerdefiniert',
		'ayanamsa.kp-newcomb': 'KP Newcomb',
		'ayanamsa.kp-old': 'KP Old',
		'ayanamsa.lahiri': 'Lahiri',
		'ayanamsa.raman': 'B.V. Raman',
		'chakra.Crown': 'Krone',
		'chakra.Heart': 'Herz',
		'chakra.Root': 'Wurzel',
		'chakra.Sacral': 'Sakral',
		'chakra.Solar Plexus': 'Solarplexus',
		'chakra.Third Eye': 'Drittes Auge',
		'chakra.Throat': 'Hals',
		'context.address': 'Adresse',
		'context.clock': 'Uhr',
		'context.license-plate': 'Kennzeichen',
		'context.phone': 'Telefonnummer',
		'context.price': 'Preis',
		'context.receipt': 'Kassenbon',
		'coordinateSystem.sidereal': 'Siderisch',
		'coordinateSystem.tropical': 'Tropisch',
		'element.Air': 'Luft',
		'element.Earth': 'Erde',
		'element.Fire': 'Feuer',
		'element.Storm': 'Sturm',
		'element.Water': 'Wasser',
		'family.akriti': 'Akriti',
		'family.asraya': 'Asraya',
		'family.classical': 'Classical',
		'family.dala': 'Dala',
		'family.sankhya': 'Sankhya',
		'focus.finance': 'Finanzen',
		'focus.general': 'Allgemein',
		'houseSystem.equal': 'Gleiche Häuser',
		'houseSystem.koch': 'Koch',
		'houseSystem.placidus': 'Placidus',
		'houseSystem.whole-sign': 'Ganzes Zeichen',
		'lang.de': 'Deutsch',
		'lang.en': 'Englisch',
		'lang.es': 'Spanisch',
		'lang.fr': 'Französisch',
		'lang.hi': 'Hindi',
		'lang.pt': 'Portugiesisch',
		'lang.ru': 'Russisch',
		'lang.tr': 'Türkisch',
		'nodeType.mean': 'Mittlerer Knoten',
		'nodeType.true': 'Wahrer Knoten',
		'planet.Jupiter': 'Jupiter',
		'planet.Mars': 'Mars',
		'planet.Mercury': 'Merkur',
		'planet.Saturn': 'Saturn',
		'planet.Venus': 'Venus',
		'scheme.eight': 'Acht Karakas',
		'scheme.seven': 'Sieben Karakas',
		'suit.cups': 'Kelche',
		'suit.pentacles': 'Münzen',
		'suit.swords': 'Schwerter',
		'suit.wands': 'Stäbe',
		'system.baladi': 'Baladi',
		'system.deeptadi': 'Deeptadi',
		'system.jagradadi': 'Jagradadi',
		'type.compound': 'Compound',
		'type.master': 'Meisterzahl',
		'type.mirror': 'Spiegelzahl',
		'type.repeating': 'Wiederholend',
		'type.root': 'Wurzelzahl',
		'type.sequential': 'Aufsteigend',
		'zodiac.aquarius': 'Wassermann',
		'zodiac.aries': 'Widder',
		'zodiac.cancer': 'Krebs',
		'zodiac.capricorn': 'Steinbock',
		'zodiac.gemini': 'Zwillinge',
		'zodiac.leo': 'Löwe',
		'zodiac.libra': 'Waage',
		'zodiac.pisces': 'Fische',
		'zodiac.sagittarius': 'Schütze',
		'zodiac.scorpio': 'Skorpion',
		'zodiac.taurus': 'Stier',
		'zodiac.virgo': 'Jungfrau',
	},
});
